import { useRouter } from "vue-router"
import { useGlobalLoading } from "../composables/useGlobalLoading"
import { defineNuxtPlugin } from "nuxt/app"

export default defineNuxtPlugin(() => {
  const { startLoading, stopLoading } = useGlobalLoading()

  // Intercetta navigazioni
  const router = useRouter()
  
  router.beforeEach((to, from) => {
    if (to.path !== from.path) {
      startLoading('Navigating...')
    }
  })
  
  router.afterEach(() => {
    stopLoading()
  })
})